import { BUSINESS_COUNTRIES } from './constants'

export const allCountryISO2Values = (businessCountries: typeof BUSINESS_COUNTRIES) => { 
  return businessCountries.reduce((iso2Values: Array<string>, region) => {
    region.countries.forEach(country => {
      iso2Values.push(country.country.iso2.toLocaleLowerCase());
    });
    return iso2Values;
  }, [])
}

export const sleep = (milliseconds: number = 1000) => {
  return new Promise((resolve) => setTimeout(resolve, milliseconds));
};

export const getDeploymentRegion = () =>
  process.env.REACT_APP_DEPLOYMENT_REGION?.toLowerCase() ?? undefined;
